module.exports = __webpack_public_path__ + "6b35b0b75442cd21f3ade9f9fb9140f8.pdf";